<a
    class="btn btn-blue material-button m-1"
    data-toggle="tooltip"
    [routerLink]="pathProcessoPage"
    [queryParams]="queryParams"
    [target]="'_blank'"
    ngbTooltip="Processos">
    <span class="material-icons md-21 py-1">view_kanban</span>
</a>
